export enum ObjectType {
  Grid = 'Grid',
  Calendar = 'Calendar',
  Graph = 'Graph',
}

export enum PageName {
  AuditList = 'AuditList',
  AuditListGraph = 'AuditListGraph',
  AuditDetails = 'AuditDetails',
  FindingListAll = 'FindingListAll',
  FindingDraftList = 'FindingDraftList',
  FindingListGraph = 'FindingListGraph',
  FindingDetails = 'FindingDetails',
  CertificateList = 'CertificateList',
  CertificateListGraph = 'CertificateListGraph',
  CertificateDetails = 'CertificateDetails',
  ScheduleList = 'ScheduleList',
  ScheduleCalendar = 'ScheduleCalendar',
  ContractList = 'ContractList',
  FinancialList = 'FinancialList',
  SettingsAdmin = 'SettingsAdmin',
  SettingsCompanyDetails = 'SettingsCompanyDetails',
  SettingsMembers = 'SettingsMembers',
  SettingsSites = 'SettingsSites',
  ActionsList = 'ActionsList',
  NotificationList = 'NotificationList',
  OverviewList = 'OverviewList',
}

export enum ObjectName {
  Audits = 'Audits',
  Findings = 'Findings',
  SubAudits = 'SubAudits',
  Sites = 'Sites',
  Documents = 'Documents',
  Certificates = 'Certificates',
  Schedules = 'Schedules',
  ScheduleCalendar = 'ScheduleCalendar',
  Contracts = 'Contracts',
  Financials = 'Financials',
  Admin = 'Admin',
  CompanyDetails = 'CompanyDetails',
  Members = 'Members',
  Actions = 'Actions',
  Notification = 'Notification',
  Overview = 'Overview',
}
